// Prefix for public assets (img/, docs/; fonts stay on the origin) that are served from the CDN
// in production. VITE_ASSET_BASE is set in .env.production; unset in dev so
// files come from ui/public as before. Drop the "/rurkt" suffix once the
// Timeweb CDN has a per-domain origin path.
const BASE = (import.meta.env.VITE_ASSET_BASE || '').replace(/\/$/, '')

export function asset(path) {
  if (!path || /^(https?:)?\/\//.test(path)) return path
  return `${BASE}${path.startsWith('/') ? '' : '/'}${path}`
}
